// extracted by mini-css-extract-plugin
export default {"innerContainer":"your-reference-search_innerContainer__mz8kO","header":"your-reference-search_header__gmWzv","boxStyle":"your-reference-search_boxStyle__RRfoX"};